import { Box, Typography, useTheme } from '@mui/material';

import { getMasterPhotoById } from '@/helpers/images-helper';
import { getPlayerIconWhenIsNotOk } from '@/helpers/players-helper';

import CustomImageComponent from '../shared/custom/custom-image';
import ApercibidosStatusIcon from '../shared/icons/apercibidos-status-icon';

const JugadoresEstadoCard = ({ player }) => {
    const theme = useTheme();
    return (
        <Box
            sx={{
                width: { xs: '20%', md: '80px' },
                padding: '2px',
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                position: 'relative',
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: '4px',
                    bgcolor: theme.palette.background.default,
                }}
            >
                <CustomImageComponent
                    src={getMasterPhotoById(player.information.id, 105)}
                    alt={player.nickname}
                    width={70}
                    height={70}
                    style={{ marginBottom: '6px' }}
                />
                <Typography
                    variant="body2"
                    sx={{
                        width: '70px',
                        height: '20px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        fontSize: '12px',
                        bgcolor: theme.palette.background.card,
                        borderRadius: '2px',
                        marginBottom: '6px',
                        color: theme.palette.text.primary,
                    }}
                    textAlign={'center'}
                >
                    {player.information?.name}
                </Typography>

                <Box sx={{ position: 'absolute', top: '-2px', right: '7px' }}>
                    {getPlayerIconWhenIsNotOk(
                        player?.generalStatus?.status,
                        player?.generalStatus?.statusLevel
                    )}
                </Box>

                <Box sx={{ position: 'absolute', top: '5px', left: '7px' }}>
                    {player?.generalStatus?.isApercibido && (
                        <ApercibidosStatusIcon iconWidth={15} iconHeight={15} />
                    )}
                </Box>
            </Box>
        </Box>
    );
};

export default JugadoresEstadoCard;
